import React from 'react';
import { Link } from 'react-router-dom';
import {ToastContainer, toast} from 'react-toastify'
const Home = (props, isAuthenticated) => {
function clearToken(){
	localStorage.removeItem('token')
}

let authed = localStorage.getItem('token')
console.log(isAuthenticated)
  return (


<>

<ToastContainer/>



<button>
					<Link to='/login'  className='Link'>Login</Link>
					
</button>

{authed ? 	<Link  onClick={clearToken()} to='/openai/m1/select' className='Link'>Logout</Link> 
 : ''}
<p className='no-over openai-text'>There are so many things to to with Artificial Intelligence. The professionals' leading the way are provide excellent tools for us developers to experience with, and it's an absolute thrill. As I learn and discover new ways to apply this amazing technolgy in real use cases, you will surely be finding at least scaled down versions in this website. Try out some of the stuff I have set up here, and I'll keep adding new utilities in the mean time. </p>;


<div className=' mlot'>

								<ul className='sublist select-ai-list'>		
<li className='mainlist-li'>
					<Link to='/openai/m1/completion/lyrics'>Create Lyrics</Link>
				</li>
													
											<li className='sublist-li'>
												<Link to='/openai/m1/completion/quotes'>Discover or Create Famous Quotes</Link>
											</li>
											
														
											<li className='sublist-li'>
												<Link to='/openai/m1/completion/build-a-resume'>Get Hired, Build your Resume Better</Link>
											</li>

											<li className='sublist-li'>
												<Link to='/openai/m1/completion/endpoints'>Find domain || API endpoints</Link>
											</li>

											<li className='sublist-li'>
												<Link to='/openai/m1/stream/gpt3'>Stream with GPT</Link>
											</li>

											<li className='sublist-li'>
												<Link to='/openai/m1/completion/storytime'>Start a new book</Link>
											</li>

											<li className='sublist-li'>
												<Link to='/openai/m1/completion/command'>REALIZE the speed of AI, and get help with the command you need NOW!</Link>
											</li>
												

											<li className='sublist-li'>
												<Link to='/openai/m1/images/'>Render Images</Link>
											</li>
									
											<li className='sublist-li'>
												<Link to='/openai/m1/completion/chores'>Make the chore plan for the week</Link>
											</li>
											<li className='sublist-li'>
												<Link to='/openai/m1/completion/chat'>Chat</Link>
											</li>
												
										

</ul>

</div>
<a className='back-link' href="/">back home</a>
</>)


}

export default Home;